module.exports = {
  "FoodC_statement__1_eIic": "（1）骑手取件后，收件人需保持电话畅通，按时到达收件地址与骑手接头。",
  "FoodC_statement_Laboratory_samples_AmoJ": "实验室样品；",
  "sailing.c-api-intl.安全码无效，请核对信息后重试": "安全码无效，请核对信息后重试",
  "FoodC_cancel_Cancellation_Policy_rnAp": "取消规则",
  "Entrega_order__grnd": "帮助中心",
  "Entrega_orderlist__qmSV": "收件地址",
  "Entrega_order__aMgd": "留言",
  "FoodC_001_The_WEB_Iizt": "WEB版本暂不支持paypay支付，使用paypay支付请下载{{download}} ",
  "Entrega_batches__rZib": "收件点{{number}}",
  "Entrega_batches__nFnq": "最多可上传{{number}}个订单，超出后的订单无法上传成功",
  "FoodB_modification_Confirmation_ehVU": "确认",
  "Entrega_orderlist__sjgm": "请输入搜索内容",
  "Entrega_order__LzLZ": "退出",
  "Entrega_order__eiaZ": "类型",
  "FoodC_cancel__free_BQFd": "骑手接单后{{free_time}} 分钟内，用户可免费取消订单",
  "Entrega_order__uvJi": "退出",
  "Entrega_Website__Slmd": "请阅读并同意协议",
  "Entrega_Website__DZVX": "请填写母亲姓氏",
  "sailing.c-api-intl.[收藏]_[操作太快]": "操作太快啦，请稍后尝试",
  "FoodC_cancel_Special_circumstances_aOpL": "特殊情况",
  "Entrega_adaptability_IzCw_ONwx": "计算",
  "Entrega_Website__FUwp": "保存",
  "FoodC_IM_Search_no_GwBf": "搜索无结果",
  "Entrega_Website__PxMa": "商家税号",
  "Entrega_order__xvAp": "请输入寄件人姓氏",
  "FoodC_statement__4_YGAs": "（4）除了现金订单所涉及的费用，您无需向骑手支付任何其他费用。",
  "FoodB_remind_Update_successfully_dcQL": "更新成功",
  "Entrega_batches__mqeT": "请输入名",
  "Entrega_batches__cpOw": "5.确认下单",
  "Entrega_order__ZAuG": "我知道",
  "Entrega_batches__uktp": "请输入姓",
  "Entrega_frontpage__opFP": "可大负载运输多个包裹",
  "FoodB_DishesMerchants_Original_price_huUe": "原价",
  "FoodC_statement__2_ZtHa": "（2）向骑手交付物品时，需仔细核实配送员身份信息，否则如将物品交付到错误的骑手手中，您应自行承担相应责任；",
  "FoodC_C_Cancel_Cqxt": "取消",
  "Entrega_order__YnnH": "DiDi Entrega Business",
  "FoodOpD_Part2_Steps_WZjI": "步骤",
  "Entrega_order__jjRu": "联系我们",
  "Entrega_order__hPwP": "请输入地址/手机号/姓名搜索",
  "Entrega_frontpage__AseG": "通过卫星实时跟踪您和您的客户",
  "Entrega_orderlist__KviE": "所有订单",
  "Entrega_order__OCDq": "影响配送费用的因素包括你的城市，从寄件到收件的距离，配送日期和配送时间",
  "Entrega_1__KChO": "内部编号",
  "Entrega_Template__EeTB": "邮编",
  "Entrega_order__Ftqh": "电话号码",
  "Entrega_Website__XohT": "密码",
  "Entrega_order__Lmqk": "一次最多填写{{number}}个收件信息",
  "Entrega_order__hRIq": "此操作将删除之前填写的订单信息, 是否继续?",
  "Entrega_Template__IWlP": "种类",
  "Entrega_frontpage__wLFi": "安全措施",
  "soda-c-i18n---订单取消成功": "",
  "FoodC_statement__1_wZhz": "（1）如骑手长时间未接单，您可免费取消订单；",
  "Entrega_frontpage__mqNg": "设置多目的地。一个送货员每次最多可携带3个包裹",
  "FoodC_demand_Determination_wKQX": "确定",
  "FoodC_cancel_Free_order_WqpG": "用户可免费取消订单",
  "Entrega_orderlist__oXqh": "复制链接",
  "Entrega_Website__xEde": "详细信息填写",
  "Entrega_batches__KCbP": "3.将文档保存在计算机上并上传",
  "FoodC_web_Customer_Service_EBqf": "客服",
  "Entrega_frontpage__sdCG": "开始下单",
  "FoodC_cancel_Courier_picked_obrP": "骑手已取件",
  "Entrega_batches__kvFM": "请选择地址",
  "GDriver_Name_DiDi_Gsik": "滴滴",
  "Entrega_Template__JAlv": "批量下单填写模板",
  "soda-b-homepage-i18n---最多不能超过%s个字": "最多不能超过%s个字",
  "FoodC_name_DiDi_Flash_TAPX": "滴滴闪送",
  "Entrega_order__sPko": "请输入寄件人名称",
  "FoodB_5_Payment_Method_qlAx": "支付方式",
  "Entrega_name_99_Flash_maAd": "99闪送",
  "FoodC_statement__3_gBJT": "（3）如骑手已取件后，您取消仍需承担订单费用；",
  "sailing.b-api-intl.滴滴外卖": "滴滴外卖",
  "FoodC_cancel_Cancel_the_MyBx": "取消结点",
  "sailing.c-api-intl.余额不足，请更换其他支付方式": "余额不足，请更换其他支付方式",
  "FoodC_revision_Contact_customer_GIZy": "联系客服",
  "FoodC_statement__2_Rrwp": "（2）骑手取件后，发/收件人均会收到收件码；如收件人未收到包含收件码的短信，发件人可在订单详情页分享配送状态和收件码给收件人，或可联系客服确认收件码；为保证物品安全，请勿提前分享收件码给骑手及其他人。",
  "Entrega_Template__ESnk": "收件信息 - 可添加任意条数收件信息",
  "Entrega_orderlist__bEoA": "进行中订单",
  "FoodD_model_Upload_MoFF": "上传",
  "Entrega_order__KZeQ": "收件地址",
  "FoodC_statement_2_How_LmUD": "2、{{entrega_name}}服务怎么用？",
  "FoodD_Compliance_Cancel_RytB": "取消",
  "dchat_QR_code_copy_failed": "复制失败",
  "FoodC_statement__5_eCLd": "（5）若因骑手在取件途中发生意外/车辆故障等原因，订单被取消，平台将为您指派其他骑手上门取件；",
  "Entrega_orderlist__xjSm": "重置",
  "Entrega_orderlist__VGtl": "订单编号",
  "Entrega_Website__nfLq": "邮箱",
  "sailing.launcher-xtx-center.支付成功": "支付成功",
  "FoodC_presentation_DiDi_Delivery_vrwd": "滴滴闪送",
  "FoodC_busy_System_busy_QOvT": "系统繁忙，请稍后重试",
  "FoodB_additional_Countless_STVD": "暂无数据",
  "Entrega_Website__uokP": "请填写商家税号",
  "Entrega_order__moic": "提醒",
  "Entrega_Template__QpcU": "重量",
  "Entrega_frontpage__jDZF": "方便且实用",
  "Entrega_batches__QUdn": "您的第{{num}}个订单信息有误，请修正后发单",
  "Entrega_frontpage__TcWu": "了解{{brand_name}}业务，现在你可以同时批量下单，并跟踪每一个包裹",
  "soda-act---添加信用卡/借记卡": "",
  "Entrega_order__pjxR": "新增收件地址",
  "Entrega_Template__gvzH": "社区",
  "Entrega_orderlist__LsHL": "至",
  "Entrega_orderlist__tBPj": "骑手姓名",
  "sailing.c-api-intl.交易失败，请核对信息后重试，或更换其他支付方式": "交易失败，请核对信息后重试，或更换其他支付方式",
  "Entrega_order__xKro": "希望骑手为您做什么？",
  "FoodC_Website_The_WEB_pBbW": "WEB版本暂不支持{{pay_name}}支付，使用{{pay_name}}支付请下载",
  "FoodC_cancel_Courier_has_LQtM": "骑手已接单",
  "FoodC_recommended_Please_select_dJyk": "请选择支付方式",
  "Entrega_Website__MiyN": "请输入真实邮箱",
  "Entrega_Website__gWFs": "名",
  "sailing.launcher-xtx-center.订单已完成": "订单已完成",
  "Entrega_Template__NTCS": "电话号码",
  "Entrega_batches__xDcS": "1.下载示例文档。",
  "Entrega_order__hETY": "计价",
  "Entrega_frontpage__vqPP": "下载APP并开始在{{brand_name_food}}或{{brand_name_entrega}}中赚钱。最好的是，你可以选择何时何地进行寄送",
  "Entrega_orderlist__ZBqk": "结束日期",
  "FoodC_statement__2_mmNa": "（2）顾客需包装帮送物品符合如下限制，使其完全适宜帮送服务",
  "FoodC_update_Grand_total_JLev": "总计",
  "Entrega_Website__InoK": "商家地址",
  "Entrega_order__qLWr": "账户管理",
  "Entrega_Website__gYJh": "请填写商家名称",
  "Entrega_order__vrTL": "姓",
  "soda-b-homepage-i18n---必须为%s字": "必须为%s字",
  "FoodC_presentation_Network_exception_SELs": "网络异常，请稍后再试",
  "Entrega_frontpage__vDfn": "支持24/7实时监控",
  "Entrega_order__NODA": "历史联系人",
  "FoodC_statement__3_PxyO": "（3）骑手取件后，若因指定的收件人的原因导致送件无法完成（包括并不限于收件人拒绝接收物品、无法同收件人取得联系或者收件地址错误等情况），发件人将恢复对物品的处理权，但需要支付相关服务费用。",
  "Entrega_batches__IMNL": "重新上传",
  "FoodC_statement_Animals_people_IccN": "动物、人、武器或爆炸物；",
  "Entrega_frontpage__SiFn": "你有一辆自行车或者摩托车嘛？",
  "Entrega_Website__BHFN": "名字",
  "Entrega_Website__WNeD": "legal curp",
  "Entrega_order__twAa": "确认删除该条收件信息？",
  "Entrega_orderlist__UVEe": "共计",
  "Entrega_Template__LQbu": "备注",
  "Entrega_order__bVVa": "名",
  "Entrega_frontpage__xEbj": "登录",
  "Entrega_batches__uLkG": "上传进度",
  "Entrega_order__sndC": "非服务时间",
  "sailing.c-api-intl.金额无效，请核对交易金额后重试": "金额无效，请核对交易金额后重试",
  "Entrega_order__zXtO": "快速发单",
  "soda-act---支付超时！": "",
  "Entrega_orderlist__moOk": "订单状态及对应的快捷操作",
  "FoodC_cancel_When_the_PAQq": "当平台检测到您频繁操作取消订单时，不可取消订单，可联系客服咨询",
  "Entrega_frontpage__DxSF": "从电脑端发起寄送！方便且实用",
  "soda-m-i18n---不能少于%s字": "",
  "Entrega_Website__ZqQD": "经营范围",
  "Entrega_batches__EZui": "请输入收件人手机号码",
  "FoodC_statement__4_Nghy": "（4）若因骑手联系不上取件人/ 收件人，取件/ 收件地址错误等原因，导致物品无法交付，您仍将承担订单费用，并需和骑手自行协商物品的返还/重新配送的时间和地点；",
  "Entrega_orderlist__CZCi": "去支付",
  "FoodC_revision_Cancel_Order_qOSA": "取消订单",
  "soda-act---复制成功": "",
  "Entrega_order__TLcb": "物品信息",
  "FoodC_statement_Currency_or_drqX": "货币或者有价证券；",
  "Entrega_order__PoSj": "您确定要退出吗？",
  "Entrega_order__kMQQ": "成为配送合作伙伴",
  "Entrega_order__RxpK": "所有订单支付成功",
  "Entrega_orderlist__vvoX": "搜索",
  "Entrega_Website__LHDQ": "姓",
  "FoodC_statement_If_you_Jbkm": "如发现物品少送、错送、丢失或损坏等情况，请您及时联系客服处理。",
  "FoodC_statement_3_Flash_IEYW": "3、订单取消规则",
  "Entrega_Website__YUgC": "城市",
  "Entrega_orderlist__QABY": "实付价格",
  "FoodC_2_Payment_failed_cDAD": "支付失败",
  "FoodC_cancel_Users_initiate_suVB": "用户可发起取消申请，申请不可撤回，待骑手返件后取消成功，取消仍需支付订单费用",
  "Entrega_batches__HjLu": "内部编号",
  "Entrega_order__Ufct": "删除",
  "FoodC_statement_Jewelry_vtUc": "珠宝；",
  "FoodC_statement_Psychotropic_drugs_XUfp": "精神药品和麻醉药品；",
  "Entrega_Template__DOSv": "外部编号",
  "FoodC_statement_pornography_WPQI": "色情材料；",
  "Entrega_Website__zsNe": "商家名称",
  "Entrega_batches__kelG": "要一次导入多个目的地并请求同时交付，您必须遵循以下说明：",
  "Entrega_frontpage__eutu": "不同的支付方式：现金或信用卡，供您选择",
  "FoodC_statement_Value_Items_svYm": "价值：价值不得超过{{value_limit}}的物品",
  "Entrega_order__ixiy": "导入发单",
  "sailing.c-api-intl.交易失败，请联系发卡行核实后重试": "交易失败，请联系发卡行核实后重试",
  "FoodC_statement_Weight_The_kJIL": "重量：单件物品重量不得超过{{weight_limit}}kg",
  "DiDi_Food_(C)_confirm_receipt_goods_received_zfyG": "确定收到货物了吗？",
  "Entrega_Website__tzsO": "修改密码",
  "Entrega_batches__SING": "文件过大不支持上传",
  "Entrega_order__vDLt": "请输入正确手机号码",
  "Entrega_Template__HRnO": "城市",
  "Entrega_order__ZUqV": "收件信息{{Number}}",
  "Entrega_orderlist__LVNZ": "创建时间",
  "soda-b-web-i18n---请选择": "请选择",
  "FoodC_unpaid_Payment_KjvL": "支付",
  "Entrega_frontpage__aFuj": "成为一名骑手",
  "soda-act---卡类型": "",
  "FoodC_statement__4_bDLh": "（4）收件人在收到帮送物品时，应打开包装，及时验收物品的数量和完整性。",
  "Entrega_Website__gJjE": "请填写first name",
  "Entrega_orderlist__qSHv": "开始日期",
  "Entrega_frontpage__GYhs": "了解更多",
  "Entrega_orderlist__SWIc": "预计取件时间",
  "Entrega_order__ynve": "重量",
  "FoodC_statement_4_Rules_XuZc": "4、订单取件规则",
  "Entrega_order_kJLM_VXYM": "点击“计算按钮”后才可切换支付方式",
  "Entrega_order__WDjM": "我们将自动跳转至订单列表页面",
  "Entrega_order__sfhO": "寄件地址",
  "Entrega_orderlist__AUmi": "收件电话",
  "FoodC_apply2_Details_Progress_rnCv": "进度详情",
  "Entrega_orderlist__eErl": "下单时间",
  "Entrega_Website__SElE": "请填写真实地址",
  "FoodC_revision_Order_Details_aiDd": "订单详情",
  "sailing.c-api-intl.卡冻结，请更换其他支付方式": "卡冻结，请更换其他支付方式",
  "FoodC_cancel_Reason_for_vfFe": "取消原因",
  "Entrega_batches__FtYJ": "信息不能为空",
  "sailing.c-api-intl.交易失败，请稍后重试": "交易失败，请稍后重试",
  "Entrega_order__IffJ": "请完善寄件信息",
  "Entrega_Template__TWzv": "详细地址",
  "Entrega_Template__ePIf": "寄件信息 - 只可填写唯一寄件信息",
  "Entrega_Website__JBYs": "请输入legal curp",
  "Entrega_frontpage__JyGP": "实时跟踪您的订单进程",
  "Entrega_Template__Xbtn": "物品信息 - 可添加任意条数物品信息",
  "Entrega_Website__gIQy": "提交",
  "Entrega_order__donF": "线上单一次最多填写{{number}}个收件信息",
  "sailing.c-api-intl.[提单页]_[总价]": "总价",
  "Entrega_Website__IqJA": "编辑",
  "Entrega_batches__IzME": "下载模板",
  "sailing.c-api-intl.无法识别卡信息，请核对信息后重试，或更换其他支付方式": "无法识别卡信息，请核对信息后重试，或更换其他支付方式",
  "Entrega_batches__YVXX": "2.填写每个字段中的信息。（请注意，文件中将有进一步说明）",
  "FoodC_statement__2_Gymp": "（2）如骑手尚未取件，在骑手接单后一定时间内，您可免费取消订单；超过一定时间后，您需要支付取消费；",
  "FoodC_part3_Order_List_uPvS": "订单列表",
  "Entrega_Website__KeKD": "手机号",
  "Entrega_order__bWrw": "取消",
  "FoodC_statement__1_hBNr": "（1）骑手接单后，需保证电话畅通，按时到达取件地址与骑手接头；",
  "FoodC_statement__1_ZXJA": "（1）发件人需根据页面提示，填写完整且准确的取/送地址、发/收件人联系方式信息，且请如实、正确填写物品信息；",
  "Entrega_batches__thYx": "重新上传将会覆盖之前的信息，是否确认重新上传",
  "sailing.c-api-intl.卡已失效，请更换其他支付方式": "卡已失效，请更换其他支付方式",
  "Entrega_frontpage__GYAk": "我们将发送一个安全代码给收件人去收货",
  "Entrega_frontpage__txIf": "多个包裹，同时运送",
  "FoodC_cancel__free_pPaN": "骑手接单后{{free_time}} 分钟后，用户有偿取消订单，需支付{{cancellation_fee}}取消费",
  "FoodC_cancel_Order_accepted_DmOH": "待骑手接单",
  "FoodC_statement_6_Lost_VmQE": "6、物品丢失/ 损毁规则",
  "Entrega_frontpage__ISae": "有了{{brand_name}}，您可以通过多种交付方式满足客户的所有需求。",
  "FoodC_cancel_Wait_uNLX": "等一等",
  "Entrega_order__XivI": "请完善收件信息",
  "Entrega_batches_Ezlu_yFWe": "请输入订单号",
  "FoodC_statement_5_Rules_eBJs": "5、订单收件规则",
  "FoodC_statement_Items_prohibited_vdcx": "任何其他相关法律禁止的物品；",
  "Entrega_Website__VXTL": "请选择寄件点所在城市",
  "Entrega_Website__tlRd": "我同意{{TC}}",
  "Entrega_order__LAgj": "请输入门牌号/公寓名称",
  "Entrega_order__OFFz": "寄件人信息",
  "Entrega_order__tUWq": "详细地址信息",
  "sailing.c-api-intl.发卡行异常，请更换其他支付方式": "发卡行异常，请更换其他支付方式",
  "Entrega_frontpage__jnfB": "更多关于{{brand_name}}",
  "Entrega_Template__DzTR": "街道",
  "Entrega_frontpage__rqcd": "输入您的物品信息，系统自动帮您产生运单",
  "FoodC_statement_Volume_The_wFKH": "体积：单件物品长宽高不得超过{{length_limit}} cm x {{width_limit}} cm x {{height_limit}} cm",
  "Entrega_batches__Olse": "4.确认所有信息",
  "Entrega_order__tugw": "请选择寄件地址",
  "Entrega_batches__OGkF": "导入订单信息",
  "FoodC_statement__6_cuGI": "（6）若因骑手取件时发现配送物品不合规，骑手则有权取消，您的物品将无法配送。",
  "Entrega_order__ozpr": "关于{{brand}}",
  "FoodC_statement_Currently_DiDi_jUEl": "目前{{entrega_name}}服务支持帮送服务，即您可以通过在客户端App上下单，让平台骑手帮忙递送物品至指定的周边地点和收件人。骑手接单后会到您指定地址取货，并将物品送往您指定的目的地和收件人。",
  "FoodC_statement_Drugs_controlled_drMh": "受管制或限制流通的药物；",
  "Entrega_orderlist__pKjE": "下载文件",
  "FoodC_statement__3_JHtK": "（3）您作为下单人/发件人需要承担该订单所涉及的费用。如线上支付订单，需在下单时完成订单费用的支付；如现金支付订单，需在骑手取货时将现金支付给骑手。收件人不需要承担或支付任何费用；",
  "Entrega_Website__PoAN": "取消",
  "Entrega_orderlist__rEhM": "历史订单",
  "FoodC_statement_1_What_SFNM": "1、{{entrega_name}}服务是什么？",
  "FoodC_cancel_When_an_XxLF": "当为线上支付订单时，用户实际支付的取消费，最多不超过实际支付的配送费",
  "FoodC_perception_View_Uhmy": "去结算",
  "Entrega_batches__aqwL": "当前格式暂不支持上传",
  "FoodC_statement_Dangerous_materials_tLOa": "危险材料或废弃物（易燃液体或固体；在压力下冷藏、液化或溶解的压缩气体；存在毒性、传染性、放射性或腐蚀性的物质）；",
  "Entrega_frontpage__lrXS": "快速有效的路线",
  "FoodC_statement_Type_You_sJki": "类型：用户不得要求{{entrega_name}}服务递送包括但不限于以下被视为违禁物品的对象：",
  "Entrega_order__CCFZ": "请输入寄件人手机号码",
  "Entrega_frontpage__EBme": "从{{fee_amount}}起发货",
  "sailing.c-api-intl.内部系统错误": "内部系统错误",
  "Entrega_orderlist__XPzy": "查看订单详情",
  "FoodC_statement__5_ZbOp": "（5）如发现物品丢失/ 损毁/ 少送/ 错送，优先与骑手协商赔偿问题，如协商不一致，则需联系客服解决。",
  "Entrega_order__Jxze": "与我们合作",
  "Entrega_batches__qVQU": "寄件点",
  "FoodD_up_Rule_description_dqPm": "规则描述",
  "Entrega_Website__Zcma": "配送物品类型",
  "Entrega_translate_VqaZ_ibpx": "订单筛选"
}